<template>
  <div class="table-content">
    <el-table :data="tableData" style="width: 100%" border>
      <el-table-column label="角色名" width="220">
        <template v-slot="scope">
          <span class="link" @click="toLink(scope.row)">
            {{ scope.row.name }}
          </span>
        </template>
      </el-table-column>
      <el-table-column prop="description" label="描述">
      </el-table-column>
    </el-table>
  </div>

</template>

<script>
import axios from 'axios';

export default {
  data() {
    return {
      tableData: []
    }
  },
  props: ['data'],
  watch: {
    data(val) {
      console.log(val);

    }
  },
  methods: {
    toLink(item) {
      console.log(item);

      const name = "角色", title = "角色";
      const query = { ...item, name, title }, path = "/roles";

      if (!this.isExistingTab(name)) {
        this.$store.commit("setShowingTabsInHome", query);
      }
      this.$store.commit("setActivedTabInHome", name);
      this.$router.push({ path, query });
    },
    getData() {
      const { id } = this.$route.query;
      axios.get('/pmdm/admin/role/getRoleByPriv?privId=' + id).then(res => {
        this.tableData = res.data.object;
      })
    }
  },
  created() {
    this.getData();
    console.log(this.data);

  },
}
</script>

<style scoped>
.table-content {
  padding: 15px;
  box-sizing: border-box;
}

.link {
  color: #409EFF;
  cursor: pointer;

  &:hover {
    color: #409EFF;
    border-bottom: 1px solid #409EFF;
  }
}
</style>